'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCorporateDetails = getCorporateDetails;
exports.parseCorporatePartnerPath = parseCorporatePartnerPath;

var _localStorage = require('redux/saga/helpers/local-storage');

var _corporate = require('constants/corporate');

var _Plan = require('derivers/Plan');

var _Plan2 = _interopRequireDefault(_Plan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCorporateDetails(planCode) {
  var corporatePartnerObj = (0, _localStorage.readLocalStorage)(_corporate.CORPORATE_PARTNER_STORAGE_KEY) || {};
  return _Plan2.default.isCorporateJustworks(planCode) && corporatePartnerObj.partner && corporatePartnerObj.partner === _corporate.CORPORATE_PARTNER_JUSTWORKS ? corporatePartnerObj : undefined;
}

function parseCorporatePartnerPath(path) {
  return path && path.split('-')[0];
}